import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../../api/analyticsApi';
import { analyticsKeys } from './analyticsKeys';

export const useAiOperations = (startDate: string, endDate: string) =>
    useQuery({
        queryKey: analyticsKeys.aiOperations(startDate, endDate),
        queryFn: () => analyticsApi.getAiOperations(startDate, endDate),
        staleTime: 5 * 60 * 1000,
    });
